import { OptimisationBase } from '@/optimizer';

export const OPTIMISATION_BASE_STYLES: Record<
    OptimisationBase,
    { label: string; border: string; tag: string; icon: string }
> = {
    budget: {
        label: 'Media Investment',
        border: 'border-blue-400 hover:border-blue-500',
        tag: 'bg-blue-100 text-blue-700 border border-blue-400',
        icon: 'from-blue-500 to-indigo-600',
    },
    media_kpi: {
        label: 'Media Contribution',
        border: 'border-orange-400 hover:border-orange-500',
        tag: 'bg-orange-100 text-orange-700 border border-orange-400',
        icon: 'from-orange-500 to-amber-600',
    },
    total_kpi: {
        label: 'Total Contribution',
        border: 'border-green-400 hover:border-green-500',
        tag: 'bg-green-100 text-green-700 border border-green-400',
        icon: 'from-green-500 to-emerald-600',
    },
};
